import { Mapper } from '../services/Mapper'

export default {
  name: 'map-view',

  created () {
    this.mapper = Mapper.instance
  },

  mounted () {
    const home = this.$storage.get('home', Mapper.defaultHome)
    this.mapper.createMap(home.center, home.zoom)
  }
}
